import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <div className="footer__brand">
        <span className="footer__name">RFR Pro</span>
        <span className="footer__tagline">Hamilton's Premier Hockey School</span>
      </div>

      <nav className="footer__nav">
        <Link to="/">Home</Link>
        <Link to="/about">Coaches</Link>
        <Link to="/reviews">Reviews</Link>
        <Link to="/contact">Contact</Link>
      </nav>

      <div className="footer__credit">
        <span>© {new Date().getFullYear()} RFR Pro. Site by </span>
        <a href="https://www.dudigital.ca" target="_blank" rel="noopener noreferrer">
          DuDigital.ca
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
